/** Matches HasModel3d::MODEL_3D_MAX_BYTES. */
export const MAX_GLB_BYTES = 30 * 1024 * 1024;

/** A file size the way the page talks about it: "2.3 MB". */
export function formatBytes(bytes: number | null | undefined) {
  if (!bytes) return '—';
  if (bytes >= 1024 ** 3) return `${(bytes / 1024 ** 3).toFixed(2)} GB`;
  if (bytes >= 1024 ** 2) return `${(bytes / 1024 ** 2).toFixed(1)} MB`;
  return `${Math.round(bytes / 1024)} KB`;
}

/** Seconds as m:ss. */
export function formatDuration(seconds: number) {
  const m = Math.floor(seconds / 60);
  const s = Math.round(seconds % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
}
